import { IconButton } from "@mui/material";
import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from "react-redux";
import { imageStudioActions } from "../../store/imageStudio";

export default function ClearPromptButton() {

  const dispatch = useDispatch();
  const prompt = useSelector((state) => state.imageStudio.prompt);

  if(!prompt) return null;
  
  return (
    <IconButton
      color="error"
      onClick={() => dispatch(imageStudioActions.setPrompt(""))}
    >
      <CloseIcon />
    </IconButton>
  );
}
